import { render, staticRenderFns } from "./SellerAllocationsTab.vue?vue&type=template&id=5cc53f74&scoped=true"
import script from "./SellerAllocationsTab.vue?vue&type=script&lang=js"
export * from "./SellerAllocationsTab.vue?vue&type=script&lang=js"
import style0 from "./SellerAllocationsTab.vue?vue&type=style&index=0&id=5cc53f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc53f74",
  null
  
)

export default component.exports